import axios from 'axios';

const headers = {
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
};

export const getCountries = async () => {
    const url = `/api/referential/countries`;
    const res = await axios.get(url, { headers });
    return res.data;
}

export const getReferers = async () => {
    const url = `/api/referential/referers`;
    const res = await axios.get(url, { headers });
    return res.data;
}

export const getCivilities = async () => {
    const url = `/api/referential/civilities`;
    const res = await axios.get(url, { headers });
    return res.data;
}

export const getPhoneExtension = async (countryCode) => {
    const url = `/api/referential/phone-extension?country=${countryCode}`;
    const res = await axios.get(url, { headers });
    return res.data;
}

export const getZipData = async (zip) => {
    const url = `/api/referential/zipcode-cities?zipCode=${zip}&country=FR`;
    const res = await axios.get(url, { headers });
    return res.data;
}

export const getMemberProfile = async () => {
    const url = `/hub/user/profile/member`;
    const res = await axios.get(url, { headers });
    return res.data;
}

export const updateMemberProfile = async (data) => {
    const url = `/hub/user/profile/member/update`;
    const res = await axios.post(url, data, { headers });
    return res;
}

export const unsubscribeMember = async () => {
    const url = `/hub/user/profile/member/unsubscribe`;
    const res = await axios.post(url, { headers });
    return res;
}

export const registerMember = async (data) => {
    const url = `/hub/auth/member/register`;
    const res = await axios.post(url, data, { headers });
    return res;
}


